/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LocationGlobeIcon16Light } from './LocationGlobeIcon16Light';
import { LocationGlobeIcon16Regular } from './LocationGlobeIcon16Regular';
import { LocationGlobeIcon16Solid } from './LocationGlobeIcon16Solid';
import { LocationGlobeIcon20Light } from './LocationGlobeIcon20Light';
import { LocationGlobeIcon20Regular } from './LocationGlobeIcon20Regular';
import { LocationGlobeIcon20Solid } from './LocationGlobeIcon20Solid';
import { LocationGlobeIcon24Regular } from './LocationGlobeIcon24Regular';
import { LocationGlobeIcon24Solid } from './LocationGlobeIcon24Solid';
import { LocationGlobeIcon32Regular } from './LocationGlobeIcon32Regular';
import { LocationGlobeIcon64Regular } from './LocationGlobeIcon64Regular';
var sizes = {
    16: {
        light: LocationGlobeIcon16Light,
        regular: LocationGlobeIcon16Regular,
        solid: LocationGlobeIcon16Solid,
    },
    20: {
        light: LocationGlobeIcon20Light,
        regular: LocationGlobeIcon20Regular,
        solid: LocationGlobeIcon20Solid,
    },
    24: {
        regular: LocationGlobeIcon24Regular,
        solid: LocationGlobeIcon24Solid,
    },
    32: {
        regular: LocationGlobeIcon32Regular,
    },
    64: {
        regular: LocationGlobeIcon64Regular,
    },
};
export var LocationGlobeIcon = forwardRef('LocationGlobeIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
